import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/railways-item-02-1024.jpg")